var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TextClassifierConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { BaseTextClassifierConfig } from './baseTextClassifierConfig';
import { ToolCategories } from './toolCategories';
import { ToolConfigInfo } from './toolConfigInfo';
import { textClassifierConfigSchemaValidation } from '../validations.generated';
export const textClassifierConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:TextClassifierConfig',
    type: 'object',
    properties: {
        options: { type: 'integer', minimum: 1, maximum: 7 }
    },
    required: ['options']
};
let TextClassifierConfig = TextClassifierConfig_1 = class TextClassifierConfig extends BaseTextClassifierConfig {
    constructor(textColumn, labelColumn, options, customFormats) {
        super(ToolType.TEXT_CLASSIFIER, textColumn, labelColumn, customFormats);
        this.options = options;
        JSON.validate(this, TextClassifierConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return TextClassifierConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return TextClassifierConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return TextClassifierConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return TextClassifierConfig_1.outs;
    }
    static get in() {
        return TextClassifierConfig_1.ins[0];
    }
    static get out() {
        return TextClassifierConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.TEXT_CLASSIFIER.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.LEARN], this.ins, this.outs, ['grade level', 'readability', 'cnn text classifier', 'bow text classifier', 'ensemble text classifier'], false);
    }
};
TextClassifierConfig = TextClassifierConfig_1 = __decorate([
    JsonSchemaV2(textClassifierConfigSchema, textClassifierConfigSchemaValidation),
    JsonDiscriminatorValue(ToolType.TEXT_CLASSIFIER)
], TextClassifierConfig);
export { TextClassifierConfig };
//# sourceMappingURL=textClassifierConfig.js.map